import { useParams } from 'react-router-dom';
import { Codelab } from '@mercedes-benz/plugin-academy';

export const CodelabTab = () => {
  const { namespace, name } = useParams<{ namespace: string; name: string }>();

  return (
    <Codelab
      showHeader={false}
      namespaceId={namespace ?? ''}
      tutorialName={name ?? ''}
    />
  );
};
